import { useState } from "react";
import { useNavigate } from "react-router-dom";

import heroImage from "../../../assets/images/homepage/Images/Hero image - web 3.0.jpg";
import appStoreBadge from "../../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg";
import googlePlayBadge from "../../../assets/images/GetItOnGooglePlay_Badge_Web_color_English.png";
import { WhiteLogoTransparent } from "../../../assets/images";
import BunnyEars from "../../../assets/images/BunnyEars.png";
import CustomModal from "../../../components/CustomModal";
import Login from "../../auth/Login";


import {
  Container,
  BackgroundImage,
  HeroLogo,
  NavButtons,
  NavSignInButton,
  NavSignUpButton,
  IntroContainer,
  HeroHeading,
  HeroSubtitle,
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
  BunnyIcon,
  AppBadgesContainer,
  AppBadge,
} from "./styles";

const HeroSection = () => {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <Container id="hero">
      <BackgroundImage src={heroImage} alt="JackedRabbit gym" />

      <NavButtons>
        <NavSignUpButton onClick={() => navigate("/signup")}>
          Sign Up
        </NavSignUpButton>
        <NavSignInButton onClick={() => setShowLoginModal(true)}>
          Sign In
        </NavSignInButton>
      </NavButtons>

      <CustomModal
        showModal={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        content={<Login />}
        backgroundColor="#ffffff"
        closeColor="#555555"
      />

      <IntroContainer>
        <HeroLogo src={WhiteLogoTransparent} alt="JackedRabbit" />
        <HeroHeading>
          One app<br />Unlimited fitness
        </HeroHeading>
        <HeroSubtitle>Explore the best gyms and studios, stay where you belong.</HeroSubtitle>

        <ButtonGroup>
          <PrimaryButton onClick={() => navigate("/signup")}>
            Become a member
          </PrimaryButton>
          <SecondaryButton onClick={() => navigate("/signup_new_partner/list")}>
            <BunnyIcon src={BunnyEars} alt="" />
            List your business &rarr;
          </SecondaryButton>
        </ButtonGroup>
      </IntroContainer>

      <AppBadgesContainer>
        <a href="https://apps.apple.com/us/app/jackedrabbit/id6747449627" target="_blank" rel="noreferrer">
          <AppBadge src={appStoreBadge} alt="Download on the App Store" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.jackedrabbitgyms.jackedrabbitmobile" target="_blank" rel="noreferrer">
          <AppBadge src={googlePlayBadge} alt="Get it on Google Play" />
        </a>
      </AppBadgesContainer>
    </Container>
  );
};

export default HeroSection;
